import cx from "classnames";
import React from "react";

import { CLASS_CONTENT } from "./constants";

interface PromotionCardContentProps {
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const PromotionCardContent: React.FC<PromotionCardContentProps> = ({
  className,
  children,
  ...other
}) => {
  const classes = cx(CLASS_CONTENT, className);
  return (
    <div className={classes} {...other}>
      {children}
    </div>
  );
};

PromotionCardContent.displayName = "PromotionCardContent";
